import { cn } from "@/modules/lib/utils"
import styled, { css } from "styled-components"
import { Text } from "@/components/ui/baseUi/text"

export const EMPTY_VIEW_VERTICAL_PADDING = 40

export type EmptyViewPaddingType = "Default" | "In_table"

export type EmptyViewProps = {
  image?: {
    src: string
    background?: string
    padding?: string
  }
  title?: string
  description?: string
  textAlign?: "center" | "left" | "right"
  button?: React.ReactNode
  flexGrow?: boolean
  children?: React.ReactNode
  paddingType?: EmptyViewPaddingType
  imagePosition?: "before" | "after"
  disposition?: "row" | "column" | "row-reverse" | "column-reverse"
  textContentClassName?: string
  className?: string
} & React.HTMLAttributes<HTMLDivElement>

export const EmptyView: React.FC<EmptyViewProps> = ({
  image,
  flexGrow,
  title,
  description,
  textAlign = "center",
  button,
  children,
  paddingType,
  imagePosition = "before",
  disposition = "column",
  textContentClassName,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-3xl",
        flexGrow && "max-h-full flex-1",
        paddingType === "Default" && "py-10",
        paddingType === "In_table" && "py-6",
        className,
      )}
      {...props}
    >
      <InformationContainer $disposition={disposition}>
        {image && imagePosition === "before" && (
          <Illustration
            $flexGrow={flexGrow}
            $imageBackgroundColor={image.background}
            className="flex"
            $padding={image.padding}
          >
            <img src={image.src} style={{ width: 200 }} />
          </Illustration>
        )}
        <div className={cn("flex flex-col gap-2 p-5", textContentClassName)}>
          {title && (
            <Text fontStyle="HS" className={`text-${textAlign}`} style={{ wordBreak: "break-word" }}>
              {title}
            </Text>
          )}
          {description && (
            // todo use good color
            <Text fontStyle="BM" className={`text-${textAlign}`} color="var(--text-color-secondary)">
              {description}
            </Text>
          )}
          {button && <div className="self-center">{button}</div>}
        </div>
        {image && imagePosition === "after" && (
          <Illustration
            $flexGrow={flexGrow}
            $imageBackgroundColor={image.background}
            className="flex"
            $padding={image.padding}
          >
            <img src={image.src} style={{ width: 200 }} />
          </Illustration>
        )}
      </InformationContainer>
      {children && <div className="flex justify-center pt-5.5">{children}</div>}
    </div>
  )
}

const Illustration = styled.div<{ $imageBackgroundColor?: string; $flexGrow?: boolean; $padding?: string }>`
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  padding: ${({ $padding }) => $padding};
  ${({ $flexGrow }) =>
    $flexGrow &&
    css`
      flex-grow: 1;
      max-height: 60%;
    `}
  ${({ $imageBackgroundColor }) =>
    $imageBackgroundColor &&
    css`
      background-color: ${$imageBackgroundColor};
      margin-bottom: 18px;
      border-radius: 22px;
    `}
`

const InformationContainer = styled.div<{ $disposition: "row" | "column" | "row-reverse" | "column-reverse" }>`
  display: flex;
  flex-direction: ${({ $disposition }) => $disposition};
  align-items: center;
`
